import React from 'react';

export default function DashboardSummary({ stats }) {
  const metrics = [
    ['Applications', stats.total_applications],
    ['Active courses', stats.active_courses],
    ['Completed courses', stats.completed_courses],
    ['Saved courses', stats.wishlist_items],
    ['LMS learning', stats.lms_learning],
    ['LMS completed', stats.lms_completed_courses]
  ];

  return (
    <dl className="learner-summary" aria-label="Your training overview">
      {metrics.map(([label, value]) => (
        <div className="learner-summary-item" key={label}>
          <dt>{label}</dt>
          <dd>{value ?? 0}</dd>
        </div>
      ))}
    </dl>
  );
}
